import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import BarMetric from '../BarMetric';

export default function EvaluationSentimentMetric({
	data,
}: {
	data: graphql.AnalyticsSentimentCount[];
}) {
	const { t } = useTranslation();
	const theme = useTheme() as any;

	const values = [
		{
			label: t('dashboard.metrics.sentimentCounts.labels.count'),
			color: theme.colors.primary,
			data: data.map(({ count }) => count),
		},
	];

	const labels = ['😥', '😕', '🤔', '🙂', '😃'];

	return <BarMetric labels={labels} values={values} />;
}
